var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 9L5 5L1 1","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronRight.defaultProps = {"width":"6","height":"10","viewBox":"0 0 6 10","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
